<script setup lang="ts">
import {ChevronRight, SlidersHorizontal, Plus} from "@lucide/vue";
import AudienceFilterChips from "@/communication/components/audience/AudienceFilterChips.vue";
import {ref} from "vue";
import {SearchItem} from "@/auto-complete-searchbar/interfaces";
import AudienceFiltersModal from "@/communication/components/audience/AudienceFiltersModal.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

defineProps<{
    mode: 'sms' | 'notification';
}>();

const filters = defineModel<SearchItem[]>('filters', {default: []});
const open = ref<boolean>(false);

const showFilters = () => {
    open.value = true;
};

defineExpose({
    showFilters
});
</script>

<template>
  <div>
    <div
      class="flex items-center rounded-lg p-3 cursor-pointer"
      :class="[
        filters.length > 0 ? 'bg-lightPurple-lightest' : '',
        !filters.length ? 'gradient text-white' : ''
      ]"
      @click="open = true"
    >
      <div class="flex gap-4 items-center flex-1">
        <div
          class="rounded-lg shadow-sm shadow-primary p-3"
          :class="[
            filters.length > 0 ? 'bg-primary text-white' : '',
            !filters.length ? 'bg-white text-primary' : ''
          ]"
        >
          <SlidersHorizontal />
        </div>
        <div class="flex-1">
          <div v-if="!filters.length">
            <p class="font-medium text-lg">
              À qui souhaitez-vous écrire ?
            </p>
            <p class="text-sm">
              Définissez votre audience pour afficher les patients correspondants.
            </p>
          </div>
          <div v-else>
            <p class="font-medium text-lg">
              Audience ciblée
            </p>
            <p class="text-muted-foreground text-sm">
              {{ filters.length }} filtre{{ filters.length > 1 ? 's' : '' }} appliqué{{
                filters.length > 1 ? 's' : ''
              }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="filters.length" class="text-primary font-medium text-[12px]">
        <span>Modifier</span>
        <ChevronRight class="inline-flex size-4" />
      </div>
      <div v-else>
        <BaseButton class="text-primary">
          <Plus class="mr-1 size-5" />
          Définir l'audience
        </BaseButton>
      </div>
    </div>
    <div v-if="filters.length" class="flex flex-row flex-wrap items-center gap-2 mt-3">
      <AudienceFilterChips :filters="filters" @on-delete="filters = $event" />
      <button
        type="button"
        class="inline-flex leading-tight items-center gap-1.5 px-4 py-1.5 rounded-full border border-dashed border-border text-sm text-muted-foreground hover:border-primary hover:text-primary transition-colors"
        @click="open = true"
      >
        <Plus class="size-3.5" />
        Ajouter un filtre
      </button>
    </div>
  </div>
  <AudienceFiltersModal
    v-model:open="open"
    :mode="mode"
    :applied-filters="filters"
    @on-confirm="filters = $event"
  />
</template>

<style scoped>

</style>
